import ListBullet from "@heroicons/react/24/solid/ListBulletIcon";
import CogIcon from "@heroicons/react/24/solid/CogIcon";
import ChartBarIcon from "@heroicons/react/24/outline/ChartBarIcon";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import CollectionsIcon from "@mui/icons-material/Collections";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EmailIcon from "@mui/icons-material/Email";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";

import { SvgIcon } from "@mui/material";

export const items = [
  {
    title: "Analytics",
    path: "/",
    icon: (
      <SvgIcon fontSize="small">
        <ChartBarIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },

  {
    title: "Manage Data",
    path: "/manage-data",
    icon: (
      <SvgIcon fontSize="small">
        <TimeToLeaveIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Manage Offers",
    path: "/offers",
    icon: (
      <SvgIcon fontSize="small">
        <LoyaltyIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },

  {
    title: "Manage Vehicles",
    path: "/vehicles",
    icon: (
      <SvgIcon fontSize="small">
        <LocalShippingIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Media Gallery",
    path: "/media-gallery",
    icon: (
      <SvgIcon fontSize="small">
        <CollectionsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },

  {
    title: "Ad Management",
    path: "/advertisement",
    icon: (
      <SvgIcon fontSize="small">
        <AdUnitsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Popular Search",
    path: "/popular-search",
    icon: (
      <SvgIcon fontSize="small">
        <AdUnitsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Feature Model",
    path: "/feature-model",
    icon: (
      <SvgIcon fontSize="small">
        <AdUnitsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Hero Model",
    path: "/hero-model",
    icon: (
      <SvgIcon fontSize="small">
        <AdUnitsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Feature Article",
    path: "/feature-article",
    icon: (
      <SvgIcon fontSize="small">
        <AdUnitsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Configuration",
    path: "/configuration",
    icon: (
      <SvgIcon fontSize="small">
        <CogIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Find A Deal Email Config",
    path: "/find-a-deal-email-config",
    icon: (
      <SvgIcon fontSize="small">
        <EmailIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Compare Cars Defaults",
    path: "/compare-defaults-config",
    icon: (
      <SvgIcon fontSize="small">
        <CompareArrowsIcon />
      </SvgIcon>
    ),
    disabled: false,
    external: false,
  },
];
